import DOMPurify from 'dompurify';

/**
 * Sanitizer voor door gebruikers aangeleverde rich-text-HTML (TipTap-editor:
 * community-posts/-reacties, newsroom-reacties). De content staat ongefilterd
 * in de database, dus dit is de verdediging op het moment van renderen — ook
 * voor payloads die er al in zitten.
 *
 * Eigen DOMPurify-instantie zodat de hooks hieronder niet lekken naar ander
 * gebruik van DOMPurify.
 */
const purify = DOMPurify(window);

const ALLOWED_TAGS = [
  'p', 'br', 'hr', 'span',
  'strong', 'b', 'em', 'i', 'u', 's', 'strike', 'code', 'pre', 'blockquote',
  'h1', 'h2', 'h3', 'h4',
  'ul', 'ol', 'li',
  'a', 'img',
];
const ALLOWED_ATTR = ['href', 'target', 'rel', 'src', 'alt', 'title', 'style'];

// TipTap TextAlign schrijft `style="text-align: …"`; elke andere inline-style valt weg.
const TEXT_ALIGN = /^\s*text-align:\s*(left|center|right|justify)\s*;?\s*$/i;

purify.addHook('uponSanitizeAttribute', (_node, data) => {
  if (data.attrName === 'style' && !TEXT_ALIGN.test(data.attrValue)) {
    data.keepAttr = false;
  }
  if (data.attrName === 'target' && data.attrValue !== '_blank') {
    data.keepAttr = false;
  }
});

purify.addHook('afterSanitizeAttributes', (node) => {
  // Externe links nooit met toegang tot window.opener.
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer nofollow');
  }
});

export function sanitizeRichHtml(html: string | null | undefined): string {
  if (!html) return '';
  return purify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
    ALLOW_ARIA_ATTR: false,
  });
}
